import React from 'react';
import { SectionLabel } from './ui/SectionLabel';
import { useCountdown } from '../hooks/useCountdown';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24);
  const units = [{
    value: pad(hours),
    label: 'HS'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEG'
  }];
  return <section className="w-full bg-ink px-5 py-14 sm:px-8 sm:py-16" data-id="element-50" data-mp="3c0b5ntgdc3ux">
      <div className="mx-auto max-w-3xl rounded-3xl border border-red-500/50 bg-ink-card p-7 text-center sm:p-10" data-id="element-51" data-mp="3h18x6wn9qa93">
        <SectionLabel className="!tracking-[0.28em] !text-red-400" data-id="element-52" data-mp="32500o2urib0d">
          ⏰ Precio de lanzamiento
        </SectionLabel>
        <p className="mt-4 font-display text-xl font-bold text-white sm:text-2xl" style={{
        fontSize: "24px"
      }} data-id="element-53" data-mp="3731i6jcji29q">
          - CIERRA EN :
        </p>

        <div className="mt-7 flex items-center justify-center gap-2 sm:gap-4" role="timer" aria-live="off" data-id="element-54" data-mp="15by6dqqwyhnl">
          {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-55" data-mp="t2d3x7nkpwls" data-mpi={index}>
              {index > 0 && <span className="font-display text-2xl font-bold text-red-500 animate-pulseSoft" data-id="element-56" data-mp="t092cwd5d9oo">
                  :
                </span>}
              <span className="min-w-[76px] rounded-2xl border border-red-500/30 bg-ink px-3 py-4 sm:min-w-[96px]" data-id="element-57" data-mp="12t7s4hkdr69v">
                <span className="block font-display text-3xl font-extrabold tabular-nums text-red-400 sm:text-4xl" data-id="element-58" data-mp="f2kklxedminu">
                  {unit.value}
                </span>
                <span className="mt-1 block text-[10px] font-semibold tracking-[0.2em] text-violeta-100/60" data-id="element-59" data-mp="o41vn1cxfu5o">
                  {unit.label}
                </span>
              </span>
            </React.Fragment>)}
        </div>

        <div className="mt-8" data-id="element-60" data-mp="1zk8ozi6k4ns4">
          <div className="h-2 w-full overflow-hidden rounded-full bg-ink-line" role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos al precio de lanzamiento tomados" data-id="element-61" data-mp="1vgu70lz25xc1">
            <div className="h-full w-[68%] rounded-full bg-red-500" data-id="element-62" data-mp="123uh92jpze57" />
          </div>
          <p className="mt-3 text-xs text-violeta-100/70 sm:text-sm" data-id="element-63" data-mp="121zx3qg9vq26">
            68% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </section>;
}